import { Component, Input } from '@angular/core';
import { InitialsPipe } from '@shared/pipes/initials.pipe';
import { NgClass } from '@angular/common';

/**
 * A small avatar-style component that displays a user's initials inside a colored bubble.
 *
 * Intended for use in tables, cards, or lists where a visual representation of the user is needed.
 * The initials are derived from the `name` input using the `InitialsPipe`.
 */
@Component({
  selector: 'app-user-bubble',
  imports: [InitialsPipe, NgClass],
  templateUrl: './user-bubble.component.html',
  styleUrl: './user-bubble.component.css'
})
export class UserBubbleComponent {
  /**
   * The full name of the user, used to extract initials.
   */
  @Input() public name?: string;

  /**
   * The background color class for the bubble. Defaults to `'bg-gray-dark'`.
   */
  @Input() public color?: string = 'bg-gray-dark';
}
